module.exports = {
    gameNetworkId:29
};


//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 19
// module chunks = 0